<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "AlertBar" });
import { Button } from "../../elements/index.js";
import "tailwindcss/tailwind.css";
export let url = "";
export let label = "Show";
</script>

<div class = 's8-alert-bar'>

    <div class = 's8-content'>
        <slot >Type something...</slot>
    </div>
    <div class = 's8-button'>
        <Button
            color = 'dark'
            size = 'sm'
            { url }
            { label }
        />
    </div>

</div>

<style>

    div.s8-alert-bar {

        position: fixed;
        width: 100%;
        display: flex;
        align-items: center;
        z-index: 30;

        padding: 7px 10px;

        background-color: #44835F;
        background-image: linear-gradient(-45deg, rgba(255,255,255,0.1) 25%,
            transparent 25%, transparent 50%,
            rgba(255,255,255,0.1) 50%,
            rgba(255,255,255,0.1) 75%,
            transparent 75%, transparent);
        background-size: 40px 40px;
        animation: move 5s linear infinite;
        color: rgba(255,255,255,1);
        border: 1px solid #44835F;
        box-shadow: 0 2px 3px 0px rgba(39,39,17,0.24);
    }

        div.s8-alert-bar div.s8-content {
            min-height: 20px;
            display: flex;
            align-items: center;
            flex-grow: 1;
        }

        @keyframes move {
            to {
                background-position: 40px 40px;
            }
        }

        div.s8-alert-bar .s8-button {
            animation: wiggle 8s ease-in-out infinite;
        }

        @keyframes wiggle {
            0% { -webkit-transform: translate(0px, 0px); }
            1% { -webkit-transform: translate(2px, 0px); }
            2% { -webkit-transform: translate(-2px, 0px); }
            3% { -webkit-transform: translate(2px, 0px); }
            4% { -webkit-transform: translate(-2px, 0px); }
            5% { -webkit-transform: translate(2px, 0px); }
            6% { -webkit-transform: translate(0px, 0px); }
            7% { -webkit-transform: translate(2px, 0px); }
            100% { -webkit-transform: translate(0px, 0px); }
        }</style>